/** ----------------------------------------
    Node Modules
 ---------------------------------------- */

import anime from 'animejs';

/** ----------------------------------------
    Move
 ---------------------------------------- */

const moveUp = (el, duration = 750, delay = 0) => {
    const children = el.childNodes;

    return new Promise((resolve) => {
        anime({
            targets: children,
            translateY: [75, 0],
            duration: duration,
            delay: anime.stagger(delay),
            easing: 'easeOutQuad',
            complete: () => resolve()
        });
    });
};

const moveDown = (el, duration = 750, delay = 0) => {
    const children = el.childNodes;

    return new Promise((resolve) => {
        anime({
            targets: children,
            translateY: [0, 75],
            duration: duration,
            delay: anime.stagger(delay),
            easing: 'easeOutQuad',
            complete: () => resolve()
        });
    });
};

/** ----------------------------------------
    Export Modules
 ---------------------------------------- */

export {
    moveUp,
    moveDown
};